import { activityCustomTypesAccessLevels } from "PFCore/helpers/custom_types";
import { AccessLevel, CustomType, ParsedSchemaProperty, Profile } from "PFTypes";

export const shouldDisplayProperty = (
  property: ParsedSchemaProperty,
  customTypes: CustomType[],
  currentProfile: Profile,
  activityCreator: Profile | null
): boolean => {
  const customType = customTypes.find((type) => type.name === property.name);

  return Boolean(
    customType &&
      [AccessLevel.ReadWrite, AccessLevel.ReadOnly].includes(
        activityCustomTypesAccessLevels(currentProfile, activityCreator)[customType.id]
      )
  );
};
